// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// export default function RCMC() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Registration Cum Membership Certificate (RCMC)</h1>

//                                   <p>Registering your business with the various authorities usually has perks and advantages. The same applies to receiving the Registration Cum Membership Certificate (RCMC). The RCMC is a certificate that authenticates an exporter who trades in products registered with an agency or Govt of India. The certificate is valid for five years. The RCMC is issued by an Export Promotion Council (EPC) / Commodity Board / Development Authority or another competent authority in foreign trade policy. Exporters from India must register with EPC, specifying their main line of business.</p>
                                  
//                                   <h2>Any person, applying for:</h2>
//                                   <p>(a) An authorization import / export permit (excluding items) listed as "restricted" items in ITC (HS))</p>
//                                   <p className="text-center">(or)</p>
//                                   <p>(b) Any other benefit or concession under FTP must be posted or uploaded to the DGFT website in the Importer-Exporter profile, the RCMC granted by the competent authority in accordance with the procedures set out in the manual of procedures, unless it is expressly excluded under FTP. Certificate of Registration as Exporter of Spices (CRES) issued by Spices Board and Certificate of Registration as Exporter of coir & coir products issued by the Coir Board are treated as a Certificate of Registration and Cum Membership (RCMC) for the purposes of this guideline.</p>
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Registering Authorities</h2>
//                                   <p>(a) In this case, the registration authority is an organization designated by the DGFT, which registers the importer/exporter as its member by issuing RCMC.</p>
//                                   <p>(b) The list of notified Registering Authorities is at Appendix-2 T</p>
//                                   <p>(c) EPCs performing because the Registering Authorities for RCMC at gift will retain to behave as Registering Authorities and difficulty RCMC to their participants until thirty first March, 2016. EPCs wishing to maintain as Registering Authority for his or her product organization thereafter shall need to comply and fulfil the situations earlier than 31st March, 2016.</p>
                              
//                                   <h2>Criteria for EPCs as Registering Authorities</h2>
//                                   <p>In order to make the EPCs genuinely democratic and participative in nature and for higher governance and transparency, the standards for them to feature as Registering Authority is being laid down as under:</p>
//                                   <p>(a) e-Voting: Electronic Voting could be obligatory for election to the posts of Vice Chairman/Vice President and Executive Committee participants a good way to making sure wider participation.</p>
//                                   <p>(b) Tenure of Elected Heads: The tenure of an elected head shall now no longer be for extra than years. The election of Chairman/President of the EPC will be thru Vice Chairman/Vice President route. However, any member having held the submit of Chairman/President and/or Vice Chairman/Vice President might also additionally come again as Vice Chairman/Vice President in the identical council after an opening of now no longer much less than four years.</p>
//                                   <p>(c) Directions of the Central Government: EPCs performing because the Registering Authorities shall abide through all instructions of the Central Government in admire of promoting and improvement of global trade.</p>
                              
//                                   <h2>Registration- cum- Membership Certificate (RCMC)</h2>
//                                   <p>(a) An exporter might also additionally, on software given in ANF 2C sign up and end up a member of EPC. On being admitted to membership, applicant will be granted forthwith Registration-cumMembership Certificate (RCMC) of EPC involved, in layout given in Appendix 2R. In case an exporter wants to get registration as a producer exporter, he shall supply proof to that effect.</p>
//                                  <p>(b) Prospective / ability exporters might also additionally, on software, sign up and end up an accomplice member of an EPC.</p>
                              
//                                   <h2>How to Apply for RCMC</h2>
//                                   <p>(a) While making use of for RCMC, an exporter has to claim his essential line of enterprise in the software. The exporter is needed to reap RCMC from the Council that's involved with the fabricated from his essential line of enterprise.</p>
//                                   <p>(b) In case an export product isn't always included through any Export Promotion Council/Commodity Board etc., RCMC in admire thereof is to be acquired from FIEO. Further, in case of multi product exporters, now no longer registered with any EPC, in which essential line of enterprise is but to be settled, the exporter has a choice to reap RCMC from Federation of Indian Exporters Organization (FIEO).</p>
//                                   <p>(c) In admire of multi product exporters having their head workplace/ registered workplace withinside the North Eastern States, RCMC can be acquired from Shellac & Forest Products Export Promotion Council (besides for the goods taken care of through APEDA, Spices Board and Tea Board).</p>
//                                   <p>(d) In admire of exporters of handicrafts and handloom merchandise from the State of Jammu & Kashmir, Director, Handicrafts, Government of Jammu & Kashmir is allowed to difficulty Registration Cum Membership Certificate (RCMC).</p>
                                  
//                                   <h2>Validity of RCMC</h2>
//                                   <p>RCMC will be deemed to be legitimate from 1st April of licensing year wherein it become issued and will be legitimate for 5 years finishing 31st March of the licensing year, until in any other case special.</p>
//                                   <p>Intimation Regarding Change in Constitution of Business of RCMC holder</p>
//                                   <p>(a) In case of alternate in ownership, constitution, call or deal with of an exporter, it will be compulsory on a part of RCMC holder to intimate such alternate to registering authority inside a length of 1 month from date of such alternate. Registering authority, however, might also additionally condone delays on merits.</p>
//                                   <p>(b) Exporter shall supply quarterly return /information of his exports of various commodities to involved registering authority. However, repute holders shall additionally ship quarterly returns to FIEO in layout special through FIEO.</p>
                              
//                                   <h2>How to De- Register?</h2>
//                                   <p>Registering authority might also additionally de-sign up an RCMC holder for a special length for violation of situations of registration. Before such deregistration, RCMC holder will be given a display purpose be aware through registering authority, and a good enough and affordable possibility to make a illustration towards the proposed de-registration. Upon de– registration, involved EPC shall intimate the identical to all RAs.</p>

//                                   <h2>Appeal Against De-registration</h2>
//                                   <p>A character aggrieved through a selection of registering authority in admire of any count linked with difficulty of RCMC might also additionally choose an attraction to DGFT or an officer detailed on this behalf inside 45 days towards stated selection and selection of appellate authority will be final</p>
//                                   <p>For more Please Click Here</p>

//                                   <h2>At Apex Services What We Do</h2>
//                                   <p>RCMC is mainly for the business which will be engaged in the export business and become a member of Export Promotion Councils/Board/Authority. Here, the Company needs to apply on the prescribed application with the fee for becoming a register member. At Apex Professional Services, we help in the preparation and filing of the application acquiring RCMC.</p>
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaFileInvoice,
  FaHandsHelping
} from "react-icons/fa";

export default function RCMC() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                E-RCMC Certificate (Registration Cum Membership Certificate)
              </h1>

              <p>
                The E-RCMC (Electronic Registration-Cum-Membership Certificate)
                is a mandatory registration issued under DGFT for exporters.
                It confirms your membership with an Export Promotion Council (EPC)
                or Commodity Board and enables access to benefits under India’s
                Foreign Trade Policy.
              </p>

              <p>
                This certificate acts as official recognition of your export
                business and is essential for availing incentives, participating
                in global trade activities, and building credibility in
                international markets.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your assistance section here if needed */}
            </Col>

          </Row>

          {/* PURPOSE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Purpose of E-RCMC
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Access export incentives and government schemes</li>
            <li><FaCheckCircle /> Establish membership with EPC/Commodity Board</li>
            <li><FaCheckCircle /> Participate in international trade events</li>
            <li><FaCheckCircle /> Enhance business credibility globally</li>
          </ul>

          {/* WHO NEEDS */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Requires E-RCMC?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Exporters applying for FTP benefits</li>
            <li><FaCheckCircle /> Businesses exporting goods or services</li>
            <li><FaCheckCircle /> Companies participating in EPC activities</li>
            <li><FaCheckCircle /> Exporters seeking global trade recognition</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Select appropriate EPC or Commodity Board</li>
            <li><FaCheckCircle /> Submit application on DGFT portal</li>
            <li><FaCheckCircle /> Upload IEC and required documents</li>
            <li><FaCheckCircle /> Verification by concerned authority</li>
            <li><FaCheckCircle /> Receive E-RCMC certificate digitally</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of E-RCMC
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Access schemes like RoDTEP, EPCG, Advance Authorization</li>
            <li><FaCheckCircle /> Recognition as registered exporter</li>
            <li><FaCheckCircle /> Easier participation in trade fairs and exhibitions</li>
            <li><FaCheckCircle /> Improves trust in international markets</li>
          </ul>

          {/* VALIDITY */}
          <h2 className="section-title">
            <FaFileInvoice className="icon" /> Validity of E-RCMC
          </h2>

          <p>
            The E-RCMC certificate is generally valid for 5 years and must be
            maintained with updated business details. Any changes in company
            structure, address, or ownership must be informed to the issuing
            authority.
          </p>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide end-to-end assistance for E-RCMC
            registration including selection of the right EPC, documentation,
            application filing, and coordination with authorities. We ensure
            quick processing and maximum benefit utilization for your export business.
          </p>

        </Container>
      </section>
    </div>
  );
}